import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

export const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: ${theme.fonts.body};
    color: ${theme.colors.text.primary};
    background-color: ${theme.colors.background};
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: ${theme.spacing.md};
  }

  h1 {
    font-size: ${theme.fontSizes['4xl']};
    letter-spacing: -0.02em;
  }

  h2 {
    font-size: ${theme.fontSizes['3xl']};
    letter-spacing: -0.01em;
  }

  h3 {
    font-size: ${theme.fontSizes['2xl']};
  }

  h4 {
    font-size: ${theme.fontSizes.xl};
  }

  p {
    margin-bottom: ${theme.spacing.md};
  }

  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    transition: color ${theme.transitions.fast};

    &:hover {
      color: ${theme.colors.primaryDark};
      text-decoration: underline;
    }
  }

  code {
    font-family: ${theme.fonts.code};
    background-color: ${theme.colors.code.background};
    padding: 0.125rem 0.25rem;
    border-radius: ${theme.radii.sm};
    font-size: 0.875em;
  }

  pre {
    font-family: ${theme.fonts.code};
    background-color: ${theme.colors.code.background};
    border: 1px solid ${theme.colors.code.border};
    border-radius: ${theme.radii.md};
    padding: ${theme.spacing.md};
    overflow-x: auto;
    margin-bottom: ${theme.spacing.md};

    code {
      background-color: transparent;
      padding: 0;
      font-size: ${theme.fontSizes.sm};
    }
  }

  button {
    font-family: inherit;
    cursor: pointer;
  }

  ::selection {
    background-color: ${theme.colors.primaryLight};
    color: ${theme.colors.text.inverse};
  }
`;